export default "__VITE_ASSET__632d342a__"